import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/area.css";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
import Loader from "../dist/Loader";

const AreaPage = () => {
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [formState, setFormState] = useState("");
  const [formCities, setFormCities] = useState([]);
  const [formCity, setFormCity] = useState("");
  const [areaName, setAreaName] = useState("");
  const [showAddForm, setShowAddForm] = useState(false);
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [editingRow, setEditingRow] = useState(null);
  const [editedArea, setEditedArea] = useState("");
  const [areas, setAreas] = useState([]);
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);

  const [showMergeModal, setShowMergeModal] = useState(false);
  const [mergedAreaName, setMergedAreaName] = useState("");
  const [mergeCityId, setMergeCityId] = useState(null);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/states`, {
        headers: getAuthHeaders(),
      })
      .then((res) => setStates(res.data))
      .catch((err) => console.error("Error fetching states:", err));
  }, []);

  useEffect(() => {
    if (!formState) {
      setFormCities([]);
      setFormCity("");
      return;
    }

    const selectedStateObj = states.find((state) => state.name === formState);
    if (selectedStateObj) {
      axios
        .get(`${BASE_URL}/api/cities/${selectedStateObj.id}`, {
          headers: getAuthHeaders(),
        })
        .then((res) => setFormCities(res.data))
        .catch((err) => console.error("Error fetching cities:", err));
    }
  }, [formState, states]);

  // Handle Add Area Submit
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formState || !formCity || !areaName) {
      alert("Please select a state, city, and enter an area name.");
      return;
    }

    const payload = {
      name: areaName,
      city_id: formCity,
    };

    axios
      .post(`${BASE_URL}/api/areas`, payload, {
        headers: getAuthHeaders(),
      })
      .then(() => {
        alert("Area added successfully!");
        setAreaName("");
        fetchAreaData();
      })
      .catch((err) => console.error("Error adding area:", err));
  };

  const fetchCitiesForDropdown = (stateName) => {
    const selectedStateObj = states.find((state) => state.name === stateName);
    if (!selectedStateObj) {
      setCities([]);
      return;
    }

    axios
      .get(`${BASE_URL}/api/cities/${selectedStateObj.id}`, {
        headers: getAuthHeaders(),
      })
      .then((res) => setCities(res.data))
      .catch((err) => console.error("Error fetching cities:", err));
  };

  const fetchAreaData = () => {
    const cityObj = cities.find((city) => city.name === selectedCity);

    if (!cityObj) {
      alert("Please select a city");
      return;
    }

    setLoading(true); // ✅ START loader

    axios
      .get(`${BASE_URL}/api/areas/${cityObj.id}`, {
        headers: getAuthHeaders(),
      })
      .then((res) => {
        setAreas(res.data);
        setSelectedAreas([]);
      })
      .catch((err) => {
        console.error("Error fetching areas:", err);
        alert("Failed to fetch areas");
      })
      .finally(() => {
        setLoading(false);
      });
  };


  const handleEdit = (area) => {
    setEditingRow(area.id);
    setEditedArea(area.name);
  };
  const totalDoctors = areas.reduce(
    (sum, area) => sum + (Number(area.doctors) || 0),
    0
  );

  const totalChemists = areas.reduce(
    (sum, area) => sum + (Number(area.chemists) || 0),
    0
  );

  // Handle Save
  const handleSave = (areaId) => {
    axios
      .put(
        `${BASE_URL}/api/areas/${areaId}`,
        { name: editedArea },
        {
          headers: getAuthHeaders(),
        }
      )
      .then(() => {
        alert("Area updated successfully!");
        setEditingRow(null);
        fetchAreaData();
      })
      .catch((err) => console.error("Error updating area:", err));
  };

  const handleCancel = () => {
    setEditingRow(null);
    setEditedArea("");
  };

  const handleCheckboxChange = (areaId) => {
    setSelectedAreas((prev) =>
      prev.includes(areaId)
        ? prev.filter((id) => id !== areaId)
        : [...prev, areaId]
    );
  };

  // const handleSelectAll = (e) => {
  //   if (e.target.checked) {
  //     setSelectedAreas(areas.map(area => area.id));
  //   } else {
  //     setSelectedAreas([]);
  //   }
  // }

  const handleSelectAll = () => {
    if (selectedAreas.length === areas.length) {
      setSelectedAreas([]);
    } else {
      setSelectedAreas(areas.map((a) => a.id));
    }
  };

  const deleteAreas = async (areaIds) => {
    if (!areaIds.length) return;

    if (!window.confirm("Are you sure you want to delete selected areas?"))
      return;
    try {
      setIsDeleting(true);

      await axios.delete(`${BASE_URL}/api/areas/bulk-delete`, {
        data: {
          area_ids: areaIds,
        },
        headers: getAuthHeaders(),
      });

      // update UI after delete
      setAreas((prev) => prev.filter((a) => !areaIds.includes(a.id)));
      setSelectedAreas([]);
    } catch (err) {
      console.error(err);
      alert("Failed to delete areas");
    } finally {
      setIsDeleting(false);
    }
  };

  const handleOpenMergeModal = () => {
    const selectedAreaObjects = areas.filter((area) =>
      selectedAreas.includes(area.id)
    );

    const uniqueCities = [
      ...new Set(selectedAreaObjects.map((a) => a.city_id)),
    ];

    if (uniqueCities.length !== 1) {
      alert("All selected areas must be from the same city!");
      return;
    }

    setMergeCityId(uniqueCities[0]);
    setMergedAreaName("");
    setShowMergeModal(true);
  };

  // Handle merge submission
  const handleMerge = () => {
    if (!mergedAreaName) {
      alert("Please enter a name for the merged area");
      return;
    }

    axios
      .post(
        `${BASE_URL}/api/areas/merge`,
        {
          area_ids: selectedAreas,
          name: mergedAreaName,
          city_id: mergeCityId,
        },
        {
          headers: getAuthHeaders(),
        }
      )
      .then((res) => {
        alert(res.data.message);
        setShowMergeModal(false);
        setSelectedAreas([]);
        fetchAreaData(); // Refresh data
      })
      .catch((err) => {
        console.error("Merge failed:", err);
        alert("Merge failed: " + (err.response?.data?.message || err.message));
      });
  };

  return (
    <div className="area-page-container flex flex-col min-h-screen bg-white  box-border">
      {/* Add Area Form */}
      {showAddForm ? (
        <div className="add-area-form-container flex flex-col p-4 border border-solid border-gray-800 rounded bg-white mt-5">
          <div className="addarea-title-container">
            <h2 className="area-title whitespace-nowrap">ADD AREA</h2>
          </div>

          <form className="area-form" onSubmit={handleSubmit}>
            {/* Three Column Row */}
            <div className="add-area-form-row flex flex-col md:flex-col justify-center  mr-56">
              {" "}
              {/* State Column */}
              <div className="add-area-filter-section1">
                <label className="add-area-filter-label">COUNTRY</label>
                <select className="add-area-form-input h-7" disabled>
                  <option value="India">India</option>
                </select>

                <label className="add-area-filter-label">STATE NAME *</label>
                <select
                  className="add-area-form-input h-7"
                  value={formState}
                  onChange={(e) => setFormState(e.target.value)}
                >
                  <option value="">Select</option>
                  {states.map((state) => (
                    <option key={state.id} value={state.name}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="add-area-filter-section2">
                <label className="add-area-filter-label">CITY NAME *</label>
                <select
                  className="add-area-form-input h-7"
                  value={formCity}
                  onChange={(e) => setFormCity(e.target.value)}
                  disabled={!formState}
                >
                  <option value="">Select</option>
                  {formCities.map((city) => (
                    <option key={city.id} value={city.id}>
                      {city.name}
                    </option>
                  ))}
                </select>

                <label className="add-area-filter-label">AREA NAME *</label>
                <input
                  type="text"
                  className="add-area-form-input border border-solid border-gray-300 h-7"
                  value={areaName}
                  onChange={(e) => setAreaName(e.target.value)}
                  placeholder="Enter area name"
                />
              </div>
            </div>

            {/* Buttons */}
            <div className="area-form-buttons-row ml-16">
              <button type="submit" className="area-btn-form-submit">
                Add Area
              </button>
              <button
                type="button"
                className="area-btn-form-cancel"
                onClick={() => setShowAddForm(false)}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="area-page-btn-container">
          <button className="btn-add-area" onClick={() => setShowAddForm(true)}>
            Add Area
          </button>
        </div>
      )}

      {/* 🔍 Filter Section */}
      <div className="area-filter-section">
        <div className="area-filter-column">
          <label className="area-filter-label">State:</label>
          <select
            className="area-filter-dropdown"
            value={selectedState}
            onChange={(e) => {
              setSelectedState(e.target.value);
              fetchCitiesForDropdown(e.target.value);
            }}
          >
            <option value="">-- Select --</option>
            {states.map((state) => (
              <option key={state.id} value={state.name}>
                {state.name}
              </option>
            ))}
          </select>

          <label className="area-filter-label">City:</label>
          <select
            className="area-filter-dropdown"
            value={selectedCity}
            onChange={(e) => setSelectedCity(e.target.value)}
            disabled={!selectedState}
          >
            <option value="">-- Select --</option>
            {cities.map((city) => (
              <option key={city.id} value={city.name}>
                {city.name}
              </option>
            ))}
          </select>
        </div>

        {/* ✅ Go Button */}
        <button className="btn-filter-go" onClick={fetchAreaData}>
          Go
        </button>
      </div>
      {selectedAreas.length > 1 && (
        <div className="flex justify-center my-6 gap-4">
          <button
            className="bg-green-600 text-white px-4 py-2 rounded"
            onClick={handleOpenMergeModal}
          >
            Merge Selected Areas
          </button>
          {selectedAreas.length > 0 && (
            <button
              className="bg-red-600 text-white px-4 py-2 rounded"
              onClick={() => deleteAreas(selectedAreas)}
            >
              Delete Selected ({selectedAreas.length})
            </button>
          )}
        </div>
      )}

      {/* 📊 Areas Table */}
      <div className="area-table-container">
        {loading && (
          <div className="flex justify-center my-6">
            <Loader />
          </div>
        )}

        <h1 class="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-4">
          <span class="text-blue-700">Area </span>
          <span class="text-blue-500">List</span>
        </h1>

        <div className="border rounded shadow  table-wrapper">
          <table className="unlock-dcr-leave-table text-sm">
            <thead className="bg-blue-500 text-white">
              <tr>
                {/* SELECT ALL */}
                <th className="w-[40px] text-center">
                  <input
                    type="checkbox"
                    onChange={handleSelectAll}
                    checked={
                      selectedAreas.length === areas.length && areas.length > 0
                    }
                  />
                </th>

                <th className="w-[60px]">S.No</th>
                <th className="w-[200px]">Area Name</th>
                <th className="w-[180px]">City</th>
                <th className="w-[160px]">State</th>
                <th className="w-[100px] text-center">No. of Doctors</th>
                <th className="w-[100px] text-center">No. of Chemists</th>
                {/* <th className="w-[120px] text-center">Action</th> */}
                {/* <th className="w-[100px] text-center">Remove</th> */}
              </tr>
            </thead>

            <tbody>
              {areas.length > 0 ? (
                areas.map((area, index) => (
                  <tr key={area.id}>
                    {/* ROW CHECKBOX */}
                    <td className="text-center">
                      <input
                        type="checkbox"
                        checked={selectedAreas.includes(area.id)}
                        onChange={() => handleCheckboxChange(area.id)}
                      />
                    </td>

                    <td>{index + 1}</td>

                    <td>
                      {editingRow === area.id ? (
                        <input
                          type="text"
                          value={editedArea}
                          onChange={(e) => setEditedArea(e.target.value)}
                          className="form-input"
                        />
                      ) : (
                        area.name
                      )}
                    </td>

                    <td>{area.city_name}</td>
                    <td>{area.state_name}</td>

                    <td className="text-center">{area.doctors || 0}</td>
                    <td className="text-center">{area.chemists || 0}</td>

                    {/* EDIT / SAVE / CANCEL */}
                    {/* <td className="text-center">
                      {editingRow === area.id ? (
                        <>
                          <button
                            className="btn-action-save mr-2"
                            onClick={() => handleSave(area.id)}
                          >
                            Save
                          </button>
                          <button
                            className="btn-action-cancel"
                            onClick={handleCancel}
                          >
                            Cancel
                          </button>
                        </>
                      ) : (
                        <button
                          className="btn-action-edit"
                          onClick={() => handleEdit(area)}
                        >
                          Edit
                        </button>
                      )}
                    </td> */}

                    {/* SINGLE DELETE */}
                    {/* <td className="text-center">
                      <button
                        className="bg-red-600 text-white px-4 py-2 rounded"
                        onClick={() => deleteAreas([area.id])}
                      >
                        Delete
                      </button>
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="no-data-message text-center py-4">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>

            <tfoot>
              <tr className="bg-blue-500 text-white font-semibold border-t">
                <td colSpan="5" className="text-right px-3 py-2">
                  Total
                </td>
                <td className="text-center px-3 py-2">{totalDoctors}</td>
                <td className="text-center px-3 py-2">{totalChemists}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {/* Merge Areas Modal */}
      {showMergeModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/40 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 p-6 relative animate-fadeIn">
            {/* Close Button (top right) */}
            <button
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 transition"
              onClick={() => setShowMergeModal(false)}
              aria-label="Close"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <h1 class="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-4">
              <span class="text-blue-700">Merge </span>
              <span class="text-blue-500">Areas</span>
            </h1>
            <p className="text-center text-gray-500 mb-6">
              Combine multiple areas into one new area.
            </p>

            <div className="mb-5">
              <label className="block text-sm font-semibold mb-1 text-gray-700">
                New Area Name
              </label>
              <input
                type="text"
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none transition"
                value={mergedAreaName}
                onChange={(e) => setMergedAreaName(e.target.value)}
                placeholder="Enter merged area name"
              />
            </div>

            <div className="mb-6">
              <label className="block text-sm font-semibold text-gray-700">
                Merging{" "}
                <span className="text-blue-600">{selectedAreas.length}</span>{" "}
                areas from:
              </label>
              <div className="mt-1 flex items-center gap-2 text-gray-600">
                <span className="font-medium">
                  {areas.find((a) => a.city_id === mergeCityId)?.city_name ||
                    "--"}
                </span>
                <span className="text-xs text-gray-400">|</span>
                <span>
                  {areas.find((a) => a.city_id === mergeCityId)?.state_name ||
                    "--"}
                </span>
              </div>
            </div>

            <div className="flex gap-4 justify-end mt-2">
              <button
                className="px-4 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-600 font-medium transition"
                onClick={() => setShowMergeModal(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-semibold shadow transition"
                onClick={handleMerge}
              >
                Merge Areas
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AreaPage;
